import { useState } from "react";
import { MediaPicker, MediaThumbnail } from "@/components/admin/MediaPicker";
import type { MediaSelection } from "@/lib/media/types";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

type MediaPickerFieldProps = {
  label?: string;
  value: MediaSelection;
  onChange: (value: MediaSelection) => void;
  allowUrlFallback?: boolean;
};

export function MediaPickerField({
  label = "Image",
  value,
  onChange,
  allowUrlFallback = true,
}: MediaPickerFieldProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="space-y-2">
      {label ? <Label className="text-xs">{label}</Label> : null}
      <MediaThumbnail
        size="sm"
        value={value}
        onOpen={() => setOpen(true)}
        onClear={() => onChange({ mediaId: null, url: null, altText: null })}
      />
      {allowUrlFallback ? (
        <div className="space-y-1">
          <Label className="text-[10px] text-muted-foreground">Or URL</Label>
          <Input
            className="h-8 text-xs"
            value={value.url ?? ""}
            onChange={(e) => onChange({ ...value, url: e.target.value, mediaId: value.mediaId })}
            placeholder="https://…"
          />
        </div>
      ) : null}
      <MediaPicker open={open} onOpenChange={setOpen} value={value} onSelect={onChange} />
    </div>
  );
}
